const products = require('./Products');

module.exports = {
  name: 'Drawer',
  props: ['drawer', 'menus', 'headerBackground'],
  data: function() {
    return {
      products: products.filter(p => p.name != this.$t('app_name')),
      headerStyle: {
        'cursor': 'pointer',
        'background-image': `url(${this.headerBackground})`
      }
    }
  },
  computed: {
    drawerVisible: {
      get: function() {
        return this.drawer
      },
      set: function(newValue) {
        this.$emit('update:drawer', newValue);
      }
    }
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    },
    goHome() {
      this.$router.push('/');
    }
  },
  template: `
<v-navigation-drawer v-model="drawerVisible" enable-resize-watcher app>
  <v-layout column align-center justify-center class="py-5" @click="goHome" :style="headerStyle">
    <h1 class="white--text">{{ $t('app_name') }}</h1>
    <h4 class="white--text">{{ $t('drawer.subheader') }}</h4>
  </v-layout>
  <v-list>
    <v-list-tile :to="item.path" v-for="item in menus" :key="item.title">
      <v-list-tile-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-divider></v-divider>
  <v-list>
    <v-list-tile @click="openUrl(item.url)" v-for="item in products" :key="item.title">
      <v-list-tile-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-navigation-drawer>
  `
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/Drawer.js
// module id = 8Q+e
// module chunks = 0